import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ContactHero from './components/ContactHero';
import ConsultationBooking from './components/ConsultationBooking';
import ContactMethods from './components/ContactMethods';
// ClientTestimonials removed

const ContactConsultationPage = () => {
  const [selectedPathway, setSelectedPathway] = useState(null);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [bookingComplete, setBookingComplete] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleConsultationClick = () => {
    const bookingSection = document.getElementById('consultation-booking');
    if (bookingSection) {
      bookingSection?.scrollIntoView({ behavior: 'smooth' });
      setShowBookingForm(true);
    }
  };

  const handlePathwaySelect = (pathway) => {
    setSelectedPathway(pathway);
    setShowBookingForm(true);
    
    // Scroll to booking form
    setTimeout(() => {
      const bookingSection = document.getElementById('consultation-booking');
      if (bookingSection) {
        bookingSection?.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleBookingComplete = (formData) => {
    console.log('Booking completed:', formData);
    setBookingComplete(true);
    
    // Show success message
    alert(`Thank you ${formData?.firstName}! Your consultation has been scheduled. You will receive a confirmation email within 2 hours with meeting details and pre-consultation materials.`);
    
    // Reset form state after a delay
    setTimeout(() => {
      setShowBookingForm(false);
      setBookingComplete(false);
      setSelectedPathway(null);
    }, 3000);
  };

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Contact & Consultation - Multi-Tier Engagement | Mirakalous</title>
        <meta 
          name="description" 
          content="Connect with our enterprise AI architects for strategic consultation, technical assessment, or partnership opportunities. Multiple engagement pathways designed for your specific needs with 24-hour response guarantee." 
        />
        <meta name="keywords" content="AI consultation, enterprise AI strategy, technical assessment, AI partnership, business consultation, AI implementation" />
        <meta property="og:title" content="Contact & Consultation - Multi-Tier Engagement | AI Enterprise Solutions" />
        <meta property="og:description" content="Expert AI consultation services with strategic, technical, and partnership pathways. 24-hour response commitment and enterprise-grade security." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/contact-consultation-multi-tier-engagement" />
      </Helmet>
      
      <main className="pt-16">
        {/* Hero Section */}
        <ContactHero onConsultationClick={handleConsultationClick} />

        {/* Engagement Pathways removed per request */}

        {/* Consultation Booking Form */}
        {showBookingForm && (
          <div id="consultation-booking">
            <ConsultationBooking 
              selectedPathway={selectedPathway}
              onBookingComplete={handleBookingComplete}
            />
          </div>
        )}

        {/* Contact Methods */}
        <ContactMethods />

        {/* Client Testimonials removed */}
        {/* Bottom CTA removed per request */}
      </main>
    </div>
  );
};

export default ContactConsultationPage;